var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'hide-filter': !_vm.showFilter},attrs:{"id":"wt-form"}},[(_vm.showFilter)?_vm._t("left"):_vm._e(),_vm._t("right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }